import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    TextField,
} from "@material-ui/core"
import { useState } from "react"
import { RegistrarLogErro } from "../../../services/clientefiel"
import useAppStore from "../../../stores/AppStore"

export default function DialogCancelamento(props) {
    const [motivoCancelamento, setMotivoCancelamento] = useState(undefined)
    const [observacao, setObservacao] = useState("")

    const cancelarPedido = useAppStore(s => s.cancelarPedido)

    const autorizacao = localStorage.getItem("chaveSistema")

    const handleChange = e => setObservacao(e.target.value)

    const handleClose = () => {
        setObservacao("")
        setMotivoCancelamento(undefined)
        props.setConfirmarCancelamento(null)
    }

    const handleCancelar = async () => {
        try {
            props.setLoading(true)

            if (!motivoCancelamento) {
                props.alertStart("Selecione o motivo do cancelamento", "warning")
                props.setLoading(false)
                return
            }

            if (observacao.length <= 3) {
                props.alertStart(
                    "O motivo do cancelamento deve ter mais de 3 caracteres",
                    "warning"
                )
                props.setLoading(false)
                return
            }

            const response = await cancelarPedido(
                props.confirmarCancelamento,
                observacao,
                props.listaMotivoCancelamento[motivoCancelamento]
            )

            if (response.retornoErro) {
                props.alertStart(response.mensagem, "error")
                props.setLoading(false)
                return
            }

            handleClose()
        } catch (error) {
            RegistrarLogErro(error, "cancelarPedido", {
                observacao,
                motivoCancelamento,
                pedido: props.confirmarCancelamento,
                autorizacao,
            })
            props.alertStart("Erro ao inesperado cancelarPedido", "error")
        }
    }

    return (
        <Dialog open={props.confirmarCancelamento} onClose={handleClose} maxWidth="xs">
            <DialogTitle>Confirmação</DialogTitle>
            <DialogContent>
                <FormControl variant="outlined" fullWidth>
                    <InputLabel>Motivo</InputLabel>
                    <Select
                        native
                        fullWidth
                        value={motivoCancelamento}
                        onChange={e => setMotivoCancelamento(e.target.value)}
                        label="Motivo"
                    >
                        <option value={undefined}>Selecione um motivo</option>
                        {Object.keys(props.listaMotivoCancelamento).map((motivoIndex, index) => {
                            const motivo = props.listaMotivoCancelamento[motivoIndex]

                            return <option value={index}>{motivo.description}</option>
                        })}
                    </Select>
                </FormControl>
                <TextField
                    label="Observação"
                    multiline
                    fullWidth
                    minRows={4}
                    variant="outlined"
                    value={observacao}
                    onChange={handleChange}
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} fullWidth variant="contained">
                    NÃO CANCELAR
                </Button>
                <Button
                    onClick={handleCancelar}
                    variant="contained"
                    fullWidth
                    style={{
                        backgroundColor: "#dc3545",
                        color: "white",
                    }}
                >
                    CANCELAR
                </Button>
            </DialogActions>
        </Dialog>
    )
}
